import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react'

interface LayoutSwitcherProviderContext {
  step?: number
  setStep?: (value: number) => void
}

const Context = createContext<LayoutSwitcherProviderContext>({})

export function useLayoutSwitcherProvider() {
  return useContext(Context)
}

export interface LayoutSwitcherProviderProps {
  children?: ReactNode | ReactNode[]
}

function LayoutSwitcherProvider({ children }: LayoutSwitcherProviderProps) {
  const [step, setStep] = useState(1)

  const providerValue = useMemo(
    () => ({
      step,
      setStep,
    }),
    [step],
  )

  return <Context.Provider value={providerValue}>{children}</Context.Provider>
}

LayoutSwitcherProvider.defaultProps = {}

export default LayoutSwitcherProvider
